<template>
  <div>
    <b-form-tags v-model="value" no-outer-focus class="mb-2">
      <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
        <ul
          id="my-custom-tags-list"
          class="list-unstyled d-inline-flex flex-wrap mb-0"
          aria-live="polite"
          aria-atomic="false"
          aria-relevant="additions removals"
        >
          <li v-for="tag in tags" :key="tag" class="list-inline-item" style="margin-bottom: 10px">
            <b-form-tag
              @remove="removeTag(tag)"
              :title="tag"
              variant="danger"
            >{{ tag }}</b-form-tag>
          </li>
        </ul>
        <b-input-group aria-controls="my-custom-tags-list">
          <input
            v-bind="inputAttrs"
            v-on="inputHandlers"
            v-on:blur="addTag()"
            :placeholder="placeholder"
            class="input-field">
        </b-input-group>
      </template>
    </b-form-tags>
  </div>
</template>

<script>
  export default {
    props: {
      placeholder: String,
      initial: {
        type: Array,
        required: false,
        default: () => [],
      },
      updateTags: Function,
    },
    data() {
      return {
        value: []
      }
    },
    watch: {
      value(newValue) {
        if(this.updateTags) {
          this.updateTags(newValue);
        }
      },
      initial(nv) {
        this.value = nv;
      }
    }
  }
</script>